import React, { useEffect, useState } from 'react';
import ListView from '../../components/views/listView';
import { HOME } from '../../../routes/paths';
import { useNavigate } from 'react-router-dom';
import { MasterMessage } from '../../../masters/masterMessages';
import moment from 'moment';
import { IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import ModalCaseManager from '../caseManager/ModalCaseManager';
import { asyncGetCaseManagement } from '../../../services/caseManagement.service';

const ListCaseManagemenet = () => {
    const navigate = useNavigate();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { id: idUserLog } = logUser || {};
    const { titleList } = MasterMessage.caseManagement;
    const [rows, setRows] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [open, setOpen] = useState<boolean>(false);
    const [idCase, setIdCase] = useState<string>('');
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const [saveLoad, setSaveLoad] = useState<boolean>(false);

    useEffect(() => {
        if (idUserLog || saveLoad) {
            asyncGetCaseManagement(idUserLog, page, pageSize)
                .then((body: any) => {
                    if (body.items !== undefined) {
                        setRows(body.items.items);
                        setLengthRows(body.items.length);
                    }
                })
                .finally(() => setLoading(false));
        }
    }, [idUserLog, page, pageSize, saveLoad]);

    const openModal = (id: string) => {
        setOpen(true);
        setIdCase(id);
    };

    const closeModal = (value: boolean) => {
        setOpen(value);
        setIdCase('');
    };

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const columns = [
        {
            field: 'field1',
            headerName: 'Número caso',
            minWidth: 150,
            flex: 0.5,
        },
        {
            field: 'field4',
            headerName: 'Fecha de creación',
            minWidth: 150,
            flex: 0.5,
            type: 'date',
            valueFormatter: (params: any) =>
                params?.value !== null
                    ? moment(params?.value).format('DD/MM/YYYY')
                    : null,
        },
        {
            field: 'field10',
            headerName: 'Propietario',
            minWidth: 120,
            flex: 0.5,
        },
        {
            field: 'type',
            headerName: 'Gestión',
            minWidth: 120,
            flex: 0.5,
        },
        {
            field: 'createdBy',
            headerName: 'Creado Por',
            minWidth: 120,
            flex: 0.5,
            valueFormatter: (params: any) =>
                params?.value !== undefined
                    ? params?.value.name + ' ' + params?.value.surname
                    : '',
        },
        {
            field: 'seeMore',
            headerName: 'Ver Más',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => (
                <>
                    <Tooltip title="Ver Más">
                        <IconButton
                            size="small"
                            onClick={() => openModal(row.id)}
                        >
                            <InfoIcon type="submit" color="primary" />
                        </IconButton>
                    </Tooltip>
                </>
            ),
        },
    ];

    return (
        <>
            <ListView
                title={titleList}
                disableAdd={true}
                onClickBack={() => navigate(HOME)}
                columns={columns}
                rows={rows}
                rowCount={lengthRows}
                disableRow={true}
                loading={loading}
                onSetPage={(paginationModel: any) => paginator(paginationModel)}
            />
            {open ? (
                <ModalCaseManager
                    open={open}
                    idCase={idCase}
                    onClose={(value) => closeModal(value)}
                    onSave={(value) => setSaveLoad(value)}
                />
            ) : null}
        </>
    );
};

export default ListCaseManagemenet;
